/* LD · Ficha de producto estilo ADOR */
(function () {
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).split('.');
    var amount = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    return (fmt || '€{{amount_with_comma_separator}} EUR').replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  class LdAdorProduct extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-ldp-json]');
      if (!dataEl) return;
      this.product = JSON.parse(dataEl.textContent);
      this.moneyFormat = this.dataset.moneyFormat;
      this.form = this.querySelector('[data-ldp-form]');
      this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
      this.atc = this.querySelector('[data-ldp-atc]');
      this.err = this.querySelector('[data-ldp-error]');
      this.selected = {};
      this.bar = this.querySelector('[data-ldp-bar]');
      var self = this;
      this.querySelectorAll('[data-ldp-option]').forEach(function (group) {
        var pos = group.dataset.position;
        var checked = group.querySelector('[aria-checked="true"]');
        if (checked) self.selected[pos] = checked.dataset.value;
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            self.selected[pos] = btn.dataset.value;
            self.onChange(true);
          });
        });
      });
      this.initGallery();
      this.initQty();
      this.initForm();
      this.initShare();
      this.initBar();
      this.initRelated();
      this.updateAvailability();
    }

    currentVariant() {
      var sel = this.selected;
      return this.product.variants.find(function (v) {
        return v.options.every(function (val, i) {
          var s = sel[String(i + 1)];
          return s === undefined || s === val;
        });
      });
    }

    onChange(userAction) {
      var v = this.currentVariant();
      var self = this;
      this.querySelectorAll('[data-ldp-option]').forEach(function (group) {
        var pos = group.dataset.position;
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.setAttribute('aria-checked', btn.dataset.value === self.selected[pos] ? 'true' : 'false');
        });
        var lbl = group.querySelector('[data-ldp-selected]');
        if (lbl) lbl.textContent = self.selected[pos] || '';
      });
      this.updateAvailability();
      if (!v) {
        this.setAtc(false, this.dataset.unavailable);
        return;
      }
      if (this.idInput) this.idInput.value = v.id;
      this.setAtc(v.available, v.available ? this.dataset.add : this.dataset.soldout);
      var price = this.querySelector('[data-ldp-price]');
      if (price) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s>' + money(v.compare_at_price, this.moneyFormat) + '</s>';
        }
        html += '<span>' + money(v.price, this.moneyFormat) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price && this.dataset.saleLabel) {
          html += '<span class="ldP-sale-badge">' + this.dataset.saleLabel + '</span>';
        }
        price.innerHTML = html;
      }
      var barV = this.bar ? this.bar.querySelector('[data-ldp-bar-variant]') : null;
      if (barV) barV.textContent = v.title === 'Default Title' ? '' : v.title;
      if (userAction) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.featured_media) this.goToMedia(String(v.featured_media.id));
      }
    }

    updateAvailability() {
      var self = this;
      var variants = this.product.variants;
      this.querySelectorAll('[data-ldp-option]').forEach(function (group) {
        var pos = group.dataset.position;
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          var ok = variants.some(function (v) {
            if (!v.available) return false;
            return v.options.every(function (val, i) {
              var p = String(i + 1);
              if (p === pos) return val === btn.dataset.value;
              return self.selected[p] === undefined || self.selected[p] === val;
            });
          });
          btn.classList.toggle('is-off', !ok);
        });
      });
    }

    setAtc(enabled, label) {
      [this.atc, this.bar ? this.bar.querySelector('[data-ldp-bar-btn]') : null].forEach(function (b) {
        if (!b) return;
        b.disabled = !enabled;
        var span = b.querySelector('span') || b;
        span.textContent = label;
      });
    }

    /* Galeria */
    initGallery() {
      var self = this;
      this.track = this.querySelector('[data-ldp-slides]');
      this.slides = Array.from(this.querySelectorAll('[data-ldp-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-ldp-thumb]'));
      this.thumbTrack = this.querySelector('[data-ldp-thumbs]');
      if (!this.track) return;
      this.thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          self.goTo(i);
        });
      });
      var prev = this.querySelector('[data-ldp-tprev]');
      var next = this.querySelector('[data-ldp-tnext]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
      var t;
      this.track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
          self.setActive(i, false);
        }, 60);
      }, { passive: true });
      this.index = 0;
      this.setActive(0, false);
      var lb = this.querySelector('[data-ldp-lb]');
      if (lb) {
        this.querySelectorAll('[data-ldp-open]').forEach(function (b) {
          b.addEventListener('click', function () {
            lb.classList.add('is-open');
            document.documentElement.style.overflow = 'hidden';
            var target = lb.querySelector('[data-lb-id="' + (b.dataset.ldpOpen || self.slides[self.index].dataset.mediaId) + '"]');
            if (target) target.scrollIntoView();
            var c = lb.querySelector('[data-ldp-lb-close]');
            if (c) c.focus();
          });
        });
        var close = function () {
          lb.classList.remove('is-open');
          document.documentElement.style.overflow = '';
        };
        lb.querySelector('[data-ldp-lb-close]').addEventListener('click', close);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
        });
      }
    }

    goTo(i) {
      var n = this.slides.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.setActive(i, true);
    }

    goToMedia(id) {
      var i = this.slides.findIndex(function (s) { return s.dataset.mediaId === id; });
      if (i > -1) this.goTo(i);
    }

    setActive(i, scrollThumb) {
      this.index = i;
      this.thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var prev = this.querySelector('[data-ldp-tprev]');
      var next = this.querySelector('[data-ldp-tnext]');
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= this.slides.length - 1;
      var th = this.thumbs[i];
      if (th && this.thumbTrack) {
        var li = th.parentElement;
        var left = li.offsetLeft - this.thumbTrack.offsetLeft;
        var tw = this.thumbTrack.clientWidth;
        if (left < this.thumbTrack.scrollLeft || left + li.offsetWidth > this.thumbTrack.scrollLeft + tw) {
          this.thumbTrack.scrollTo({ left: left - (tw - li.offsetWidth) / 2, behavior: scrollThumb ? 'smooth' : 'auto' });
        }
      }
    }

    /* Cantidad */
    initQty() {
      var input = this.querySelector('[data-ldp-qty]');
      if (!input) return;
      this.querySelectorAll('[data-ldp-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.dataset.ldpQtyBtn === 'plus' ? 1 : -1;
          input.value = Math.max(1, v);
        });
      });
    }

    /* Carrito: anade y abre el carrito lateral LD (como ADOR) */
    initForm() {
      var self = this;
      if (!this.form) return;
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!self.atc || self.atc.disabled) return;
        self.atc.classList.add('is-loading');
        self.atc.setAttribute('aria-busy', 'true');
        if (self.err) self.err.textContent = '';
        var fd = new FormData(self.form);
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (document.querySelector('ld-cart-drawer')) {
              document.dispatchEvent(new CustomEvent('ld:cart:added', { detail: res.j }));
            } else {
              window.location.href = root + 'cart';
            }
          })
          .catch(function (err) {
            if (self.err) self.err.textContent = err.message;
          })
          .finally(function () {
            self.atc.classList.remove('is-loading');
            self.atc.removeAttribute('aria-busy');
          });
      });
    }

    /* Compartir */
    initShare() {
      var btn = this.querySelector('[data-ldp-share]');
      if (!btn) return;
      var msg = this.querySelector('[data-ldp-share-msg]');
      btn.addEventListener('click', function () {
        var url = btn.dataset.url;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (msg) {
              msg.textContent = btn.dataset.copied;
              setTimeout(function () { msg.textContent = ''; }, 2500);
            }
          });
        }
      });
    }

    /* Barra fija */
    initBar() {
      var bar = this.bar;
      if (!bar || !this.atc || !('IntersectionObserver' in window)) return;
      var self = this;
      document.body.appendChild(bar);
      var barBtn = bar.querySelector('[data-ldp-bar-btn]');
      if (barBtn) {
        barBtn.addEventListener('click', function () {
          if (self.form.requestSubmit) self.form.requestSubmit();
          else self.form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
      var link = bar.querySelector('[data-ldp-bar-link]');
      if (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var opts = self.querySelector('[data-ldp-options]') || self.form;
          opts.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        });
      }
      var below = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          below = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', below);
        });
      });
      io.observe(this.atc);
    }

    /* Productos relacionados */
    initRelated() {
      var box = this.querySelector('[data-ldp-rel]');
      if (!box) return;
      var self = this;
      var url = box.dataset.url;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var list = tmp.querySelector('[data-ldp-rel-src]');
          if (!list || !list.children.length) return;
          var target = box.querySelector('[data-ldp-rel-list]');
          target.innerHTML = list.innerHTML;
          box.hidden = false;
          self.paginateRelated(box);
        })
        .catch(function () {});
    }

    paginateRelated(box) {
      var items = Array.from(box.querySelectorAll('[data-ldp-rel-item]'));
      var per = 3;
      var pages = Math.ceil(items.length / per);
      var nav = box.querySelector('[data-ldp-rel-nav]');
      var cur = box.querySelector('[data-ldp-rel-cur]');
      var tot = box.querySelector('[data-ldp-rel-tot]');
      var page = 0;
      function show() {
        items.forEach(function (it, i) { it.hidden = Math.floor(i / per) !== page; });
        if (cur) cur.textContent = page + 1;
      }
      if (tot) tot.textContent = pages;
      if (nav) nav.hidden = pages < 2;
      box.querySelectorAll('[data-ldp-rel-go]').forEach(function (b) {
        b.addEventListener('click', function () {
          page = (page + (b.dataset.ldpRelGo === 'next' ? 1 : -1) + pages) % pages;
          show();
        });
      });
      show();
    }
  }

  if (!customElements.get('ld-ador-product')) customElements.define('ld-ador-product', LdAdorProduct);
})();
